<template>
  <v-timeline
      align-top
      dense
  >
    <v-timeline-item
        v-for="(message, index) in messages"
        :key="index"
        :color="message.color"
        small
    >
        <div class="font-weight-normal">
          <strong>{{ message.symbol}} - {{message.action}}: ${{message.price}}</strong>  @ {{ message.time }}
        </div>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
export default {
  name: "PositionTimeline",
  props: ['messages']
}
</script>

<style scoped>

</style>